import { render, staticRenderFns } from "./LandingTour.vue?vue&type=template&id=89335862&"
import script from "./LandingTour.vue?vue&type=script&lang=js&"
export * from "./LandingTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports